export default __webpack_public_path__ + "static/media/offing-jess-yuan.b045f214.webp";